window.addEventListener(
  "load",
  function () {
    const body = document.body;
    const navToggle = document.querySelector(".nav-toggle");
    const nav = document.getElementById("site-navigation");
    const desktopMQ = window.matchMedia("(min-width: 1280px)");

    if (!nav) return;

    /* =========================
       MOBILE NAV – HAMBURGER
    ========================= */

    function handleNavToggleClick() {
      const isOpen = body.classList.toggle("nav-active");
      navToggle.setAttribute("aria-expanded", String(isOpen));
    }

    navToggle?.addEventListener("click", handleNavToggleClick);

    /* =========================
       SUBMENU HANDLING
    ========================= */

    const submenuParents = nav.querySelectorAll(".menu-item-has-children");

    submenuParents.forEach((parent) => {
      const link = parent.querySelector(":scope > a");
      const submenu = parent.querySelector(":scope > .sub-menu");

      if (!link || !submenu) return;

      /* A11Y setup */
      link.setAttribute("aria-haspopup", "true");
      link.setAttribute("aria-expanded", "false");

      /* -------------------------
         Inject angle toggle button
      -------------------------- */
      const toggleBtn = document.createElement("button");
      toggleBtn.className = "submenu-toggle";
      toggleBtn.setAttribute("aria-label", "Toggle submenu");
      toggleBtn.setAttribute("aria-expanded", "false");
      toggleBtn.innerHTML =
        '<i class="fa-solid fa-angle-down" aria-hidden="true"></i>';

      link.after(toggleBtn);

      /* -------------------------
         Parent link behavior (mobile)
         First tap opens, second navigates
      -------------------------- */
      link.addEventListener("click", (e) => {
        if (desktopMQ.matches) return;

        if (!parent.classList.contains("submenu-open")) {
          e.preventDefault();
          parent.classList.add("submenu-open");
          link.setAttribute("aria-expanded", "true");
          toggleBtn.setAttribute("aria-expanded", "true");
        }
      });

      /* -------------------------
         Angle icon toggle
         Open / close only
      -------------------------- */
      toggleBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = parent.classList.contains("submenu-open");

        parent.classList.toggle("submenu-open");
        link.setAttribute("aria-expanded", String(!isOpen));
        toggleBtn.setAttribute("aria-expanded", String(!isOpen));
      });

      /* -------------------------
         Keyboard support
      -------------------------- */
      toggleBtn.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleBtn.click();
        }
      });

      link.addEventListener("keydown", (e) => {
        if (desktopMQ.matches) return;

        if (e.key === "Escape") {
          parent.classList.remove("submenu-open");
          link.setAttribute("aria-expanded", "false");
          toggleBtn.setAttribute("aria-expanded", "false");
          link.focus();
        }
      });
    });

    /* =========================
       LOCATION ICONS
       .locations-navmenu submenu links
    ========================= */

    const locationLinks = nav.querySelectorAll(
      ".locations-navmenu .sub-menu li > a",
    );

    locationLinks.forEach((link) => {
      if (link.querySelector(".fa-location-dot")) return;

      const icon = document.createElement("i");
      icon.className = "fa-sharp fa-solid fa-location-dot";
      icon.setAttribute("aria-hidden", "true");

      link.prepend(icon);
    });

    /* =========================
       CHECK IN BTN
    ========================= */

    const checkInBtn = nav.querySelector("#pages-menu .nav-button a");

    if (checkInBtn) {
      // Only run once
      if (!checkInBtn.querySelector("span")) {
        const text = checkInBtn.textContent.trim();
        checkInBtn.textContent = "";

        const span = document.createElement("span");
        span.textContent = text;

        const icon = document.createElement("i");
        icon.className = "fa-light fa-angle-right";
        icon.setAttribute("aria-hidden", "true");

        checkInBtn.append(span, icon);
      }
    }

    /* =========================
       RESET ON DESKTOP SWITCH
    ========================= */

    function resetNavState() {
      body.classList.remove("nav-active");
      navToggle?.setAttribute("aria-expanded", "false");

      nav.querySelectorAll(".submenu-open").forEach((item) => {
        item.classList.remove("submenu-open");
        const link = item.querySelector(":scope > a");
        const toggle = item.querySelector(":scope > .submenu-toggle");
        link?.setAttribute("aria-expanded", "false");
        toggle?.setAttribute("aria-expanded", "false");
      });
    }

    desktopMQ.addEventListener("change", resetNavState);
  },
  false,
);
